import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class BossryutsuInterview extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }
    var questionStyle ={
      fontSize:16,
      fontWeight:600
    }

    var answerStyle = {
      fontSize:16
    }

    var interviewerNoteStyle = {
      fontSize: 13,
      fontStyle: "italic"
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>February Rank 1 Interview with Bossryutsu</h1>


          <p style={size13}>
            By: Psynight - March 14, 2018 - Photo by Daniel Jensen on Unsplash
          </p>

          <img src={"../ArticleImages/BossFeb1-310x180.jpg"} style={imgCenterStyle} className="img-fluid" id="boss" alt="boss" />
          <p style={answerStyle}>
            Welcome to the second installment of our rank 1 interview series.
            The goal of these interviews is to highlight the monthly rank 1 players and get their insights into the meta and what it takes to get to the top.
          </p>
          <p style={questionStyle}>
            Congratulations on getting to the top! Rank 1 in progression and number 1 on the Leaderboard quiet the achievement.!  How long have you been playing Nova Blitz?
          </p>
          <p style={answerStyle}>
            Since the start of February 2018
          </p>
          <p style={questionStyle}>
            How did you find out about the game?
          </p>
          <p style={answerStyle}>
            I invest in the crypto space. Esports and gaming are my number one field. So I looked for more ways to work on both and I found Nova Blitz.
          </p>
          <p style={questionStyle}>
            Is this your first time at rank 1?
          </p>
          <p style={answerStyle}>
            Yes! I saw how little movement went down on the leaderboard and how little everyone played so I put in 150 hours in the first week.
            During that time I pushed to second under uni before I took a break. When I came back I went 15-0 vs real players and it just happened.
          </p>
          <p style={questionStyle}>
            Do you have a favorite faction combo, what is it about that combo that you like?
          </p>
          <p style={answerStyle}>
            Anything with Arcane or Divine in it. Removal is so important.  Every other faction goes well with one of the two.
          </p>
          <p style={questionStyle}>
            {"What's your favorite deck currently?"}
          </p>
          <img src={"../ArticleImages/BossDeck.jpg"} style={imgCenterStyle} className="img-fluid" id="bossdeck" alt="bossdeck"  />
          <p style={answerStyle}>
             The idea is to control the game with removal. Cast goblin war cry once my hand has a few answers and win of Teddy Bombs.
          </p>
          <p style={questionStyle}>
            Did you grind with one deck, or was it more quest of the day type grinding?
          </p>
          <p style={answerStyle}>
            I did almost all my grinding with the same win condition.  Boom Tinkerer is so hard to deal with when combined with Goblin battle cry. I run only that one goblin so I always get all 3 unless I drew them earlier. From there when combined with control it’s so easy to farm Teddy Bomb. I’m calling for a increase in the casting cost of the effect. Turn 2 is way to fast to start getting plus in hand.
          </p>
          <p style={interviewerNoteStyle}>
            Interview Note: A recent update seemed to have fixed the issue in which Boom Tinkerer did not create Bombs.  He definitely does now, so your mileage on the above strat may vary.
          </p>
          <p style={questionStyle}>
            Do you have a preferred archtype?  (aggro, mid range, control)
          </p>
          <p style={answerStyle}>
            Aggro is good but control is really strong in this game. So much board clear and so much removal unless you can win by turn 4 aggro is just not consistent enough. Cull of the weak makes sure of that ;)
          </p>
          <p style={questionStyle}>
            Do you have any advice to new players?
          </p>
          <p style={answerStyle}>
            My advice is more for those grinding the leaderboard. I see so many of you lose matches to bots. Sure you can beat them easy but after rank 6 the loss is not worth it at all. It’s a card game so that loss will happen. Give your points to a person not a bot.
            If you cancel the queue after about 30-40 secs and requeue you will eventually find a player and you won’t be fighting a bot when that other player queues.
          </p>
          <p style={questionStyle}>
            What are you most looking forward to next in Nova Blitz?
          </p>
          <p style={answerStyle}>
            {"Honestly I’m looking forward to playing again. I’m currently on a different grind in a different game but I still plan to come back and take March as another leaderboard first. I’m hoping more people break the rank 6 barrier so I can start farming points off them. Waiting 2 weeks for everyone to catch up last month was discouraging."}
          </p>
          <p style={questionStyle}>
            Any final thoughts or views on Nova Blitz you would like to share?
          </p>
          <p style={answerStyle}>
            {"Nova please spend time building your own chat system. The fact that I can’t open chat on the main screen and see every past message others have sent. nobody will use it over telegram. Not having this option tells me new players won’t be able to communicate with the community properly and lose out on learning from the discussions had. On top of the fact that we can’t communicate when people are offline makes it a useless feature in the game. Only used to express salty statements after a loss… Leave a comment if you feel the same way and let’s show Nova that we NEED this!"}
          </p>
          <p style={questionStyle}>
            Thanks for your time and good luck next month!
          </p>

        </div>
          <ArticleComments articleId={"4"} />
      </div>


    );
  }
}

export default BossryutsuInterview;



// WEBPACK FOOTER //
// ./src/Articles/BossryutsuInterview.js